import React, { Component } from 'react';
import { Box, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@material-ui/core';
import IncomeDetails from './IncomeDetails';
import { isEmpty } from 'lodash-es';
import PopUp from '../../../commonModules/interface/PopUp';
import { Alert } from '@material-ui/lab';
import Currency from '../../../commonModules/Currency';
import { incomeLinks, remaining } from '../../../../../../jsx/utils/paymentIncomeLinks';


class PaymentSingle extends Component {
    state = {
        income: {},
        noMatch: true,
        sms: [],
        smsLoading: true,
        errors: {
            incomeID: ""
        }
    }

    componentDidMount() {
        this.getIncome()
        this.getPaymentSms()
    }
    // Récupère le(s) SMS corrélé(s) à ce paiement (A8N-102). Le backend reconstruit
    // le lien (accountId + fenêtre temporelle + boxId/code), il n'y a pas de FK directe.
    getPaymentSms = async () => {
        try {
            if (!this.props.getPaymentSmsInfo || !this.props.payment.paymentID) {
                this.setState({ smsLoading: false })
                return
            }
            const res = await this.props.getPaymentSmsInfo(this.props.payment.paymentID)
            const list = (res && res.resp && Array.isArray(res.resp.list)) ? res.resp.list : []
            this.setState({ sms: list, smsLoading: false })
        } catch (error) {
            this.setState({ sms: [], smsLoading: false })
        }
    }
    getIncome = async () => {
        if (this.props.payment.income_id){
            const res = await this.props.getIncomeInfo(this.props.payment.income_id)
            if (!res.error && res.income_amount !== 0) {
                // noMatch part à true : sans cette remise à false, le détail de la recette
                // n'était jamais affiché.
                this.setState({
                    income: res,
                    noMatch: false,
                    errors: {
                        incomeID: ""
                    }
                })
            } else {
                this.setState({
                    noMatch: true
                })
            }
        } else {
            this.setState({
                errors: {
                    incomeID: "Veuillez remplir ce champ"
                }
            })
        }
    }

    render() {
        const { payment } = this.props;
        const {noMatch, income, sms, smsLoading} = this.state;
        return (
            <PopUp
                title={`Paiement n°${payment.transactionId} ` }
                close={this.props.handleClose}
                // submitAction={ isEmpty(income) ?  this.getIncome : this.validate}
                // submitTitle={isEmpty(income) ? "Rechercher": "Valider"}
                // submitColor={isEmpty(income) && "primary" }
                appbar
                // disabledSubmit={isEmpty(this.props.incomeID)}
            >
                <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Box p={1}>
                        {!noMatch && !isEmpty(income) &&
                            <IncomeDetails income={income} />
                        }
                        {noMatch &&
                            <Alert severity="warning">Pas de recette liée</Alert>
                        }
                    </Box>
                    {/* Pointage partiel : un paiement peut être réparti sur plusieurs recettes 5000. */}
                    {incomeLinks(payment).length > 0 &&
                        <List dense>
                            <ListItem>
                                <ListItemText primary={<Typography variant="subtitle1">Recettes 5000 rattachées</Typography>} />
                            </ListItem>
                            {incomeLinks(payment).map(link =>
                                <ListItem key={link.income_id}>
                                    <ListItemText primary={`Recette ${link.income_id}`} />
                                    <ListItemSecondaryAction>
                                        <Typography variant="body2" color="secondary"><Currency value={link.amount} /></Typography>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )}
                            <ListItem>
                                <ListItemText primary="Reste à pointer" />
                                <ListItemSecondaryAction>
                                    <Typography variant="body2" color="secondary"><Currency value={remaining(payment)} /></Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                        </List>
                    }
                </Grid>
                    <Grid item xs={12} sm={6}>
                        <List style={{ maxHeight: "500px", overflow: "auto"}}>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Date du paiement</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {new Date(payment.timePayment).toLocaleString('fr-FR')}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Box ID</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.boxId}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Montant</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                <Currency value={payment.money} />
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Durée</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {`${payment.day} jour${payment.day > 1 && "s"}`} 
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Code</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.codeId}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Info</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.info}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Type de paiement</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.typePayment}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            
                        </List>
                    </Grid>
                    <Grid item xs={12}>
                        <Box p={1}>
                            <Typography variant="subtitle1" gutterBottom>SMS envoyé</Typography>
                            {smsLoading &&
                                <Typography variant="body2" color="textSecondary">Recherche du SMS…</Typography>
                            }
                            {!smsLoading && sms.length === 0 &&
                                <Alert severity="info">Aucun SMS envoyé pour ce paiement</Alert>
                            }
                            {!smsLoading && sms.map((item, idx) => {
                                const ok = item.status === "OK" && (item.successed || []).length > 0
                                return (
                                    <Alert
                                        key={item.id || idx}
                                        severity={ok ? "success" : "error"}
                                        style={{ marginBottom: 8 }}
                                    >
                                        <Typography variant="body2">{item.content}</Typography>
                                        <Typography variant="caption" color="textSecondary" component="div">
                                            {`${ok ? "Envoyé" : "Échec"} · ${item.broker || "—"} · ${item.timeSent ? new Date(item.timeSent).toLocaleString('fr-FR') : ""}${(item.receivers && item.receivers.length) ? " · " + item.receivers.join(", ") : ""}`}
                                        </Typography>
                                    </Alert>
                                )
                            })}
                        </Box>
                    </Grid>
                </Grid>

            </PopUp>
        );
    }
}

export default PaymentSingle;

// {
//     "paymentID": "pd1665570661_126458",
//     "type": "paymentDescription",
//     "accountID": "1576577560-VUWSP2NcHciWvqZ",
//     "recordPayment": "2022-10-12T10:31:08.458085283Z",
//     "transactionId": "16655255194307327",
//     "methodPayment": "Angaza-Manual",
//     "typePayment": "Angaza-Manual",
//     "boxId": "66873225",
//     "boxAssoId": "1597398512-HiZEEthDsGSWMIZ",
//     "money": 10000,
//     "day": 30,
//     "kwh": 0,
//     "timePayment": "2022-10-11T22:00:36Z",
//     "codeId": "*749 383 099 483 08#",
//     "currency": "XOF",
//     "sessionToken": "16655255194307327",
//     "info": "Pay by +22997414740",
//     "codeUniqueId": "16655255194307327",
//     "extraInfo": "1665570668-3d514c38-c216-4",
//     "externalpartnerid": "PA376935230"
// }